<template>
  <div>
    <label
      v-if="label"
      class="form-label">{{ label }}</label>
    <div
      ref="colorpicker"
      class="input-group color-picker flex">
      <input
        v-model="colorValue"
        :disabled="disabled"
        :class="{ 'block-not-valid': !isValidHexColor }"
        class="color-input"
        placeholder="Pick colour"
      >

      <div class="color-picker-container">
        <b-form-input
          v-model="colorValue"
          type="color" />
          <!-- <span
          :style="colorBox()"
          class="current-color"
          @click="togglePicker()"/> -->
      </div>

      <!-- <div style="position:relative">
        <chrome-picker
          v-show="picker === 'chrome' && displayPicker"
          :value="colors"
          :class="noInput ? 'vc-left' : 'vc-right'"
          @input="updateFromPicker" />
        <sketch-picker
          v-show="picker === 'sketch' && displayPicker"
          :value="colors"
          :class="noInput ? 'vc-left' : 'vc-right'"
          @input="updateFromPicker" />
        <compact-picker
          v-show="picker === 'compact' && displayPicker"
          :value="colors"
          :class="noInput ? 'vc-left' : 'vc-right'"
          @input="updateFromPicker" />
      </div> -->
    </div>
    <span
      v-show="!isValidHexColor"
      class="font-not-valid">Hex Color Code Not Valid</span>
  </div>
</template>

<script>
import { Chrome, Sketch, Compact } from 'vue-color';

export default {
  components: {
    'chrome-picker': Chrome,
    'sketch-picker': Sketch,
    'compact-picker': Compact,
  },
  inheritAttrs: false,
  props: {
    noInput: {
      type: Boolean,
      default: () => false,
    },
    color: {
      type: String,
      default: () => '',
    },
    label: {
      type: String,
      default: () => '',
    },
    picker: {
      type: String,
      default: () => 'chrome',
      validator: value => ['chrome', 'compact', 'sketch'].indexOf(value) !== -1,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      colors: {
        hex: '#000000',
      },
      colorValue: null,
      displayPicker: false,
      defaultColor: '#FF0000',
      isValidHexColor: true,
    };
  },
  watch: {
    colorValue(val) {
      if (val) {
        // this.updateColors(val);
        this.$emit('input', val);
        this.isValidHexColor = /^#[0-9A-F]{6}$/i.test(val);
      }
    },

    color(val) {
      this.setColor(val || '#000000');
    },
  },
  mounted() {
    this.setColor(this.color || '#000000');
  },
  methods: {
    colorBox() {
      const border = this.noInput ? '4px' : '0px 4px 4px 0px';
      return `background-color: ${this.colorValue};
                    border-radius: ${border}
                    `;
    },
    setColor(color) {
      // this.updateColors(color);
      this.colorValue = color;
    },
    updateColors(color) {
      if (color.slice(0, 1) === '#') {
        this.colors = {
          hex: color,
        };
      } else if (color.slice(0, 4) === 'rgba') {
        const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',');
        // eslint-disable-next-line
        const hex = `#${((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1)}`;
        this.colors = {
          hex,
          a: rgba[3],
        };
      }
    },
    showPicker() {
      document.addEventListener('click', this.documentClick);
      this.displayPicker = true;
    },
    hidePicker() {
      document.removeEventListener('click', this.documentClick);
      this.displayPicker = false;
    },
    togglePicker() {
      // eslint-disable-next-line
      this.displayPicker ? this.hidePicker() : this.showPicker();
    },
    updateFromInput() {
      this.updateColors(this.colorValue);
    },
    updateFromPicker(color) {
      this.colors = color;
      if (color.rgba.a === 1) {
        this.colorValue = color.hex;
      } else {
        this.colorValue = `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a})`;
      }
      // this.displayPicker = false;
    },
    documentClick(e) {
      const el = this.$refs.colorpicker;
      const target = e.target;
      if (el !== target && !el.contains(target)) {
        this.hidePicker();
      }
    },
  },
};
</script>

<style>
  .vc-left {
    left: -39px;
  }
  .vc-right {
    right: 0;
  }
  .color-input {
    padding: .5rem;
    line-height: 1.5;
    display: block;
    width: 70%;
    border: 1px solid #ddd;
    color: #808285;
    background-color: #fff;
    border-radius: .25rem;
    text-align: left;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    position: relative;
    margin-right: 5px;
    height: 35px;
    font-size: 14px;
  }
  .color-picker {
    position: relative;
    display: flex;
    width: 100%;
  }
  .block-not-valid {
    border: 1px solid #bc1b1b;
  }
  .font-not-valid {
    color: #bc1b1b;
  }
  .vc-chrome,
  .vc-compact,
  .vc-sketch {
    position: absolute !important;
    top: 42px;
    z-index: 100;
  }
  .current-color {
    display: inline-block;
    width: 35px;
    height: 35px;
    background-color: #000;
    cursor: pointer;
    border-radius: 5px !important;
    border: 1px solid #ddd;
  }
  .color-picker-container {
    width: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/components/color-picker/jColorPicker.vue